module.exports = __webpack_public_path__ + "assets/img/30_837.60776240.jpg";